import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_EVENT_LIST,
  RECEIVE_EVENT_LIST,
  REQUEST_RIDER_LIST,
  RECEIVE_RIDER_LIST
} from '../actions/library'

export default handleActions({
  [REQUEST_EVENT_LIST]: (state, action) => {
    const { event } = state

    if (event && Object.keys(event).length === 0) {
      state = update(state, {
        event: {$set: {
          isFetching: true
        }}
      })
    }

    return state
  },
  [RECEIVE_EVENT_LIST]: (state, action) => {
    const event_items = action.payload.data.events

    state = update(state, {
      event: {$set: {
        items: event_items
      }}
    })

    return state
  },
  [REQUEST_RIDER_LIST]: (state, action) => {
    const { rider } = state

    if (rider && Object.keys(rider).length === 0) {
      state = update(state, {
        rider: {$set: {
          isFetching: true
        }}
      })
    }

    return state
  },
  [RECEIVE_RIDER_LIST]: (state, action) => {
    const rider_items = action.payload.data.riders

    state = update(state, {
      rider: {$set: {
        items: rider_items
      }}
    })

    return state
  }
}, {
  event: {},
  rider: {}
})



// WEBPACK FOOTER //
// ./src/reducers/library.js